import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Spin, Upload, Row, Col, message, Select, Input, Radio, Popover } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import moment from 'moment';//日期格式化导包
import stdApplyJobModalStroke from '../../public/img/std/stdApplyJobModalStroke.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import exports from '../../public/img/std/export.png';
import tag1 from '../../public/img/tag/tag1.png';
import saveImg from '../../public/img/newMain/Save.png';
import stdApplyingAvatar from '../../public/img/newMain/stdApplyingAvatar.png'
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'
import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';
import './turnitinEulaModal.css'
import FileViewer from 'react-file-viewer';

const { Option } = Select;
const { TextArea } = Input;
const TurnitinEulaModal = (props) => {

    const [isLoad, setIsLoad] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [turnitinEulaVersionModel, setTurnitinEulaVersionModel] = useState({});
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        searchByLatest();
    }, []);

    useEffect(() => {
        if (turnitinEulaVersionModel?.eulaVersionPage) {
            setHtmlContent(turnitinEulaVersionModel.eulaVersionPage);
        }
    }, [turnitinEulaVersionModel]);

    const searchByLatest = () => {
        Base.callBackApi("turnitinEulaVersion/searchByLatest").then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object ?? {};
                setTurnitinEulaVersionModel(model);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const save = () => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        Base.callBackApi('turnitinEulaVersion/acceptEula').then((data) => {
            if ("SUCCESS" === data.msg) {
                props.onClose(true);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        props.onClose(false);
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            footer={false}
            className='turnitinEulaModal'
        >
            <Spin size="large" spinning={isLoad} >
                <div className='contentBox'>
                    <iframe className='iframeBox'
                        srcDoc={htmlContent}
                        title="Turnitin EULA"
                    />
                    <div className='buttonBox'>
                        <div className='websiteSysButton saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Accept</div>
                        <div className='websiteSysButton cancelButton' onClick={cancel}><img src={cancelImg} />Cancel</div>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

TurnitinEulaModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}
export default TurnitinEulaModal;